import React, { useEffect, useState } from "react";
import { TextInput, Button, Link } from "pepsico-ds";
import { useTranslation } from "react-i18next";
import "./auth.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";

function Login() {
  const { oktaAuth } = useOktaAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const checkAuthenticationAndRedirect = async () => {
      const isAuthenticated = await oktaAuth.isAuthenticated();
      
      // Check for redirect param in URL
      const params = new URLSearchParams(location.search);
      const redirectPath = params.get("redirect");
      
      if (isAuthenticated) {
        // If redirect param exists, navigate there; otherwise go to home
        if (redirectPath) {
          const target = redirectPath.startsWith("/") ? redirectPath : `/${redirectPath}`;
          navigate(target, { replace: true });
        } else {
          navigate("/home");
        }
      } else {
        // Save redirect target before Okta login
        if (redirectPath) {
          const target = redirectPath.startsWith("/") ? redirectPath : `/${redirectPath}`;
          oktaAuth.setOriginalUri(target);
        }
        await oktaAuth.signInWithRedirect();
      }
    };
    checkAuthenticationAndRedirect();
  }, [oktaAuth, navigate, location.search]);
}

export default Login;
